import React from 'react';
import { Phone, ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Hero = () => {
  return (
    <section id="anasayfa" className="relative min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 pt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={companyInfo.logo} 
            alt="Sağlık Tur" 
            className="h-24 md:h-32 w-auto mx-auto drop-shadow-2xl"
          />
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          <span className="text-blue-400">{companyInfo.slogan.split(',')[0]}</span>
          <br />
          <span>{companyInfo.slogan.split(',')[1]}</span>
        </h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
          {companyInfo.description}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-lg transition-colors duration-300 font-semibold text-lg shadow-lg shadow-blue-600/25"
          >
            <Phone size={22} />
            <span>Hemen Ara</span>
          </a>
          <a
            href="#hizmetler"
            className="flex items-center gap-2 border-2 border-slate-600 hover:border-blue-500 text-slate-300 hover:text-blue-400 px-8 py-4 rounded-lg transition-all duration-300 font-semibold text-lg"
          >
            <span>Hizmetlerimiz</span>
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <a href="#hizmetler" className="text-slate-500 hover:text-blue-400 transition-colors">
            <ChevronDown size={32} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
